'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _financeCalculatorModal = require('./financeCalculator.modal.html');

var _financeCalculatorModal2 = _interopRequireDefault(_financeCalculatorModal);

var _financeCalculatorPcpModal = require('./financeCalculatorPcp.modal.html');

var _financeCalculatorPcpModal2 = _interopRequireDefault(_financeCalculatorPcpModal);

var _dealNotesModal = require('./dealNotes.modal.html');

var _dealNotesModal2 = _interopRequireDefault(_dealNotesModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FinanceQuotesController = function () {
  function FinanceQuotesController(authService, financeCompaniesManagementService, $q, $scope, $uibModal, utilsService, loadingService, enums, printService, growl) {
    "ngInject";

    (0, _classCallCheck3.default)(this, FinanceQuotesController);
    this.authService = authService;
    this.financeCompaniesManagementService = financeCompaniesManagementService;
    this.$q = $q;
    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.utilsService = utilsService;
    this.loadingService = loadingService;
    this.enums = enums;
    this.printService = printService;
    this.growl = growl;

    this.financeCompanies = [];
    this.hpTexts = [];
    this.pcpTexts = [];

    this.$scope.$on('finance:initialized', this.financeInitialized.bind(this));
  }

  (0, _createClass3.default)(FinanceQuotesController, [{
    key: 'financeInitialized',
    value: function financeInitialized() {
      var _this = this;

      this.loadFinanceCompanies().then(function () {
        _this.updateQuotes();
      });
    }
  }, {
    key: 'loadFinanceCompanies',
    value: function loadFinanceCompanies() {
      var _this2 = this;

      var deferred = this.$q.defer();

      this.financeCompaniesManagementService.listFinanceCompanies(this.authService.authData.currentLocation.key).then(function (response) {
        _this2.financeCompanies = response.data.items;
        _this2.financeCompanies.unshift({ 'financeCompanyId': null, name: 'Please Select' });

        deferred.resolve();
      });

      return deferred.promise;
    }
  }, {
    key: 'updateQuotes',
    value: function updateQuotes() {
      var _this3 = this;

      this.hpTexts[0] = this.getFinanceText(this.enums.FINANCE_TYPE.HP, 0);
      this.hpTexts[1] = this.getFinanceText(this.enums.FINANCE_TYPE.HP, 1);
      this.hpTexts[2] = this.getFinanceText(this.enums.FINANCE_TYPE.HP, 2);
      this.pcpTexts[0] = this.getFinanceText(this.enums.FINANCE_TYPE.PCP, 0);

      this.finance.financeOptions.map(function (opt) {
        opt.amountToFinance = _this3.finance.priceBreakdown.financeAmount;
        opt.financeCompany = (0, _lodash.find)(_this3.financeCompanies, function (o) {
          return o.financeCompanyId === opt.financeCompanyId;
        });
      });
    }
  }, {
    key: 'viewHpCalculator',
    value: function viewHpCalculator(isStandalone, optionIndex) {
      var ctrl = this;

      //Clear Watchers
      if (ctrl.watcher1) {
        this.watcher1();
      }

      //Props
      ctrl.$scope.errMsg = '';
      ctrl.$scope.financeCompanies = ctrl.financeCompanies;
      ctrl.$scope.optionIndex = optionIndex;
      ctrl.$scope.isStandalone = isStandalone;
      ctrl.$scope.rateHidden = true;

      if (isStandalone) {
        ctrl.$scope.financeCalc = ctrl.getFinanceOption(ctrl.enums.FINANCE_TYPE.HP, null);
        ctrl.$scope.financeCalc.financeType = ctrl.enums.FINANCE_TYPE.HP;
      } else {
        ctrl.$scope.financeCalc = ctrl.getFinanceOption(ctrl.enums.FINANCE_TYPE.HP, optionIndex);
      }

      //Methods
      ctrl.$scope.$ctrl = ctrl;
      ctrl.$scope.calculateAmount = ctrl.calculateAmount;
      ctrl.$scope.calculateMonthly = ctrl.calculateMonthly;
      ctrl.$scope.calculateTerm = ctrl.calculateTerm;
      ctrl.$scope.calculateRate = ctrl.calculateRate;
      ctrl.$scope.validateFinanceValues = ctrl.validateFinanceValues;
      ctrl.$scope.validatePositiveNo = ctrl.validatePositiveNo;
      ctrl.$scope.closeModal = ctrl.closeModal.bind(ctrl);
      ctrl.$scope.saveOption = ctrl.saveOption.bind(ctrl);

      ctrl.$scope.loadingService = ctrl.loadingService;
      ctrl.$scope.utilsService = ctrl.utilsService;

      ctrl.modalInstance = ctrl.$uibModal.open({
        template: _financeCalculatorModal2.default,
        scope: ctrl.$scope
      });
    }
  }, {
    key: 'viewPcpCalculator',
    value: function viewPcpCalculator(isStandalone, optionIndex) {
      var ctrl = this;

      //Props
      ctrl.$scope.errMsg = '';
      ctrl.$scope.financeCompanies = ctrl.financeCompanies;
      ctrl.$scope.optionIndex = optionIndex;
      ctrl.$scope.isStandalone = isStandalone;
      ctrl.$scope.rateHidden = true;

      if (isStandalone) {
        ctrl.$scope.financeCalc = ctrl.getFinanceOption(ctrl.enums.FINANCE_TYPE.PCP, null);
      } else {
        ctrl.$scope.financeCalc = ctrl.getFinanceOption(ctrl.enums.FINANCE_TYPE.PCP, optionIndex);
      }

      ctrl.watcher1 = ctrl.$scope.$watch('financeCalc.deposit', this.updateFigures.bind(this));

      //Set Net / Gross Figures
      ctrl.updateFigures();

      this.updateDeposit();

      //Methods
      ctrl.$scope.$ctrl = ctrl;
      ctrl.$scope.calculateAmount = ctrl.calculateAmount;
      ctrl.$scope.calculateMonthly = ctrl.calculateMonthly;
      ctrl.$scope.calculateTerm = ctrl.calculateTerm;
      ctrl.$scope.calculateRate = ctrl.calculateRate;
      ctrl.$scope.validateFinanceValues = ctrl.validateFinanceValues;
      ctrl.$scope.validatePositiveNo = ctrl.validatePositiveNo;
      ctrl.$scope.closeModal = ctrl.closeModal.bind(ctrl);
      ctrl.$scope.saveOption = ctrl.saveOption.bind(ctrl);
      ctrl.$scope.toggleNet = ctrl.toggleNet.bind(ctrl);

      ctrl.$scope.sliderOptions = {
        floor: 10,
        ceil: 30,
        hideLimitLabels: true,
        onChange: this.updateDeposit.bind(this),
        onEnd: this.updateDeposit.bind(this)
      };

      ctrl.$scope.loadingService = ctrl.loadingService;
      ctrl.$scope.utilsService = ctrl.utilsService;

      ctrl.modalInstance = ctrl.$uibModal.open({
        template: _financeCalculatorPcpModal2.default,
        scope: ctrl.$scope
      });
    }
  }, {
    key: 'updateDeposit',
    value: function updateDeposit() {
      var deposit = 0;

      this.$scope.financeCalc.amountToFinance = this.finance.priceBreakdown.vehiclePrice - (this.finance.priceBreakdown.tradeIn || 0) - (this.finance.priceBreakdown.discount || 0) - (this.$scope.financeCalc.deposit || 0) + (this.finance.priceBreakdown.warranty || 0) + (this.finance.priceBreakdown.accessories || 0) + (this.finance.priceBreakdown.settlement || 0);

      this.$scope.financeCalc.calculatedDeposit = Math.round(this.$scope.vehiclePrice * this.$scope.financeCalc.depositPercent / 100, 2);
      this.$scope.financeCalc.calculatedCashback = this.$scope.tradeInEquity + parseInt(this.$scope.financeCalc.deposit) - this.$scope.financeCalc.calculatedDeposit;
    }
  }, {
    key: 'updateFigures',
    value: function updateFigures() {
      this.$scope.vehiclePrice = this.finance.priceBreakdown.vehiclePrice + this.finance.priceBreakdown.accessories;
      this.$scope.tradeInEquity = this.finance.priceBreakdown.tradeIn + parseInt(this.$scope.financeCalc.deposit) - this.finance.priceBreakdown.settlement;

      if (this.$scope.financeCalc.net) {
        this.$scope.vehiclePrice -= this.finance.priceBreakdown.tradeInOverAllowance;
        this.$scope.tradeInEquity -= this.finance.priceBreakdown.tradeInOverAllowance;
      }

      this.$scope.tradeInEquityPercent = this.$scope.tradeInEquity / this.$scope.vehiclePrice * 100;

      this.updateDeposit();
    }
  }, {
    key: 'toggleNet',
    value: function toggleNet() {
      this.$scope.financeCalc.net = !this.$scope.financeCalc.net;

      this.updateFigures();
      this.updateDeposit();
    }
  }, {
    key: 'calculateAmount',
    value: function calculateAmount() {
      var _this4 = this;

      this.errMsg = '';

      var valuesToValidate = [
      /*{name: 'IRR', val: this.financeCalc.irr, allowEmpty: false},*/
      { name: 'Finance Term', val: this.financeCalc.term, allowEmpty: false }, { name: 'Monthly', val: this.financeCalc.monthly, allowEmpty: false }];

      if (!this.validateFinanceValues(valuesToValidate)) {
        return;
      }

      this.loadingService.showLoading('financeCalc', 'Updating Calculations ...');

      this.utilsService.calculateAmount(this.financeCalc).then(function (response) {
        _this4.financeCalc.amountToFinance = response.data;
      }).finally(function () {
        _this4.loadingService.hideLoading('financeCalc');
      });
    }
  }, {
    key: 'calculateMonthly',
    value: function calculateMonthly() {
      var _this5 = this;

      this.errMsg = '';

      var valuesToValidate = [{ name: 'Amount To Finance', val: this.financeCalc.amountToFinance, allowEmpty: false },
      /*{name: 'IRR', val: this.financeCalc.irr, allowEmpty: false},*/
      { name: 'Finance Term', val: this.financeCalc.term, allowEmpty: false }];

      if (!this.validateFinanceValues(valuesToValidate)) {
        return;
      }

      this.loadingService.showLoading('financeCalc', 'Updating Calculations ...');

      this.utilsService.calculateMonthly(this.financeCalc).then(function (response) {
        _this5.financeCalc.monthly = response.data;
      }).finally(function () {
        _this5.loadingService.hideLoading('financeCalc');
      });
    }
  }, {
    key: 'calculateTerm',
    value: function calculateTerm() {
      var _this6 = this;

      this.errMsg = '';

      var valuesToValidate = [{ name: 'Amount To Finance', val: this.financeCalc.amountToFinance, allowEmpty: false },
      /*{name: 'IRR', val: this.financeCalc.irr, allowEmpty: false},*/
      { name: 'Monthly', val: this.financeCalc.monthly, allowEmpty: false }];

      if (!this.validateFinanceValues(valuesToValidate)) {
        return;
      }

      this.loadingService.showLoading('financeCalc', 'Updating Calculations ...');

      this.utilsService.calculateTerm(this.financeCalc).then(function (response) {
        _this6.financeCalc.term = response.data;
      }).finally(function () {
        _this6.loadingService.hideLoading('financeCalc');
      });
    }
  }, {
    key: 'calculateRate',
    value: function calculateRate() {
      var _this7 = this;

      this.errMsg = '';

      var valuesToValidate = [{ name: 'Amount To Finance', val: this.financeCalc.amountToFinance, allowEmpty: false }, { name: 'Finance Term', val: this.financeCalc.term, allowEmpty: false }, { name: 'Monthly', val: this.financeCalc.monthly, allowEmpty: false }];

      if (!this.validateFinanceValues(valuesToValidate)) {
        return;
      }

      this.loadingService.showLoading('financeCalc', 'Updating Calculations ...');

      this.utilsService.calculateRate(this.financeCalc).then(function (response) {
        _this7.financeCalc.irr = response.data;
      }).finally(function () {
        _this7.loadingService.hideLoading('financeCalc');
      });
    }
  }, {
    key: 'validateFinanceValues',
    value: function validateFinanceValues(arrValues) {
      var _this8 = this;

      var isValid = true;
      arrValues.forEach(function (item) {
        if (!_this8.validatePositiveNo(item.val, item.allowEmpty)) {
          if (_this8.$scope) {
            _this8.$scope.errMsg = item.name + ' must be a number and greater than 0';
          } else {
            _this8.errMsg = item.name + ' must be a number and greater than 0';
          }
          isValid = false;
        }
      });

      return isValid;
    }
  }, {
    key: 'validatePositiveNo',
    value: function validatePositiveNo(val, allowEmpty) {
      if (!allowEmpty) {
        if (!val || typeof val === 'undefined' || val === null) {
          return false;
        }

        if (!isFinite(val)) {
          return false;
        }

        if (val <= 0) {
          return false;
        }

        return true;
      } else {
        if (!val) {
          return true;
        }

        if (!isFinite(val)) {
          return false;
        }

        if (val <= 0) {
          return false;
        }

        return true;
      }
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.modalInstance.close();
    }
  }, {
    key: 'saveOption',
    value: function saveOption() {
      var valuesToValidate = [{ name: 'Amount To Finance', val: this.$scope.financeCalc.amountToFinance, allowEmpty: false },
      /*{name: 'IRR', val: this.$scope.financeCalc.irr, allowEmpty: false},*/
      { name: 'Finance Term', val: this.$scope.financeCalc.term, allowEmpty: false }, { name: 'Monthly', val: this.$scope.financeCalc.monthly, allowEmpty: false }];

      if (this.$scope.financeCalc.financeCompany.financeCompanyId === null) {
        this.$scope.errMsg = 'You must select a Finance Company';
        return;
      } else if (!this.validateFinanceValues(valuesToValidate)) {
        return;
      }

      switch (this.$scope.financeCalc.financeType) {
        case this.enums.FINANCE_TYPE.HP:
          this.updateFinanceOption(this.enums.FINANCE_TYPE.HP, this.$scope.optionIndex, this.$scope.financeCalc);
          this.hpTexts[this.$scope.optionIndex] = this.getFinanceText(this.enums.FINANCE_TYPE.HP, this.$scope.optionIndex);
          break;

        case this.enums.FINANCE_TYPE.PCP:
          this.updateFinanceOption(this.enums.FINANCE_TYPE.PCP, this.$scope.optionIndex, this.$scope.financeCalc);
          this.pcpTexts[this.$scope.optionIndex] = this.getFinanceText(this.enums.FINANCE_TYPE.PCP, this.$scope.optionIndex);
          break;
      }

      this.closeModal();

      if (!this.finance.selectedOption) {
        if (this.$scope.financeCalc.financeType === this.enums.FINANCE_TYPE.HP) {
          this.finance.selectedOption = 'hp' + this.$scope.optionIndex;
        } else {
          this.finance.selectedOption = 'pcp' + this.$scope.optionIndex;
        }
      }

      this.$scope.$emit('saveFinance', { skipNotification: false });
    }
  }, {
    key: 'getFinanceText',
    value: function getFinanceText(financeType, optionIndex) {
      var option = null;

      option = (0, _lodash.find)(this.finance.financeOptions, function (o) {
        return o.financeType === financeType && o.index === optionIndex;
      });

      if (option) {
        return '\u20AC' + option.monthly + ' for ' + option.term + ' months';
      } else {
        return 'Click here to update values';
      }
    }
  }, {
    key: 'getFinanceOption',
    value: function getFinanceOption(financeType, optionIndex) {
      var option = (0, _lodash.find)(this.finance.financeOptions, function (o) {
        return o.financeType === financeType && o.index === optionIndex;
      });
      //debugger;
      if (financeType === this.enums.FINANCE_TYPE.HP && !option) {
        if (optionIndex === null) {
          //Standalone Version
          option = {
            financeCompany: this.financeCompanies[0],
            amountToFinance: this.finance.priceBreakdown.financeAmount,
            financeType: this.enums.FINANCE_TYPE.HP,
            irr: 0,
            term: 0,
            monthly: 0
          };
        } else {
          option = {
            financeId: this.finance.financeId,
            financeCompany: this.financeCompanies[0],
            amountToFinance: this.finance.priceBreakdown.financeAmount,
            financeType: this.enums.FINANCE_TYPE.HP,
            irr: 0,
            term: 0,
            monthly: 0,
            index: optionIndex
          };
        }

        option.net = false;
      }

      if (financeType === this.enums.FINANCE_TYPE.PCP && !option) {
        if (optionIndex === null) {
          //Standalone Version
          option = {
            financeCompany: this.financeCompanies[0],
            amountToFinance: this.finance.priceBreakdown.financeAmount,
            depositPercent: 10,
            financeType: this.enums.FINANCE_TYPE.PCP,
            irr: 0,
            term: 36,
            monthly: 0,
            proposedMileage: 'N/A'
          };
        } else {
          option = {
            financeId: this.finance.financeId,
            financeCompany: this.financeCompanies[0],
            amountToFinance: this.finance.priceBreakdown.financeAmount,
            depositPercent: 10,
            financeType: this.enums.FINANCE_TYPE.PCP,
            irr: 0,
            term: 36,
            monthly: 0,
            proposedMileage: 'N/A',
            index: optionIndex
          };
        }

        option.net = false;
      }

      if (financeType === this.enums.FINANCE_TYPE.PCP) {
        option.deposit = this.finance.priceBreakdown.deposit;
        option.gmfv = this.finance.priceBreakdown.gmfv || 0;
      }

      return option;
    }
  }, {
    key: 'updateFinanceOption',
    value: function updateFinanceOption(financeType, optionIndex, financeOption) {
      var option = (0, _lodash.find)(this.finance.financeOptions, function (o) {
        return o.financeType === financeType && o.index === optionIndex;
      });

      if (option) {
        option = financeOption;
      } else {
        this.finance.financeOptions.push(financeOption);
      }
    }
  }, {
    key: 'isOptionSelectable',
    value: function isOptionSelectable(financeType, optionIndex) {
      return (0, _lodash.find)(this.finance.financeOptions, function (o) {
        return o.financeType === financeType && o.index === optionIndex;
      }) == null;
    }
  }, {
    key: 'viewQuotation',
    value: function viewQuotation(selectedOption) {
      if (!this.finance.selectedOption) {
        this.growl.error('Please provide at least one finance option first', { ttl: 5000 });
        return;
      }

      this.printService.printFinanceQuotation(this.finance.financeId, selectedOption);
    }
  }, {
    key: 'editNotes',
    value: function editNotes() {
      this.errMsg = '';
      this.modalHeader = 'Update Deal Notes';
      this.modelProp = this.finance.dealNotes;

      this.modalInstance = this.$uibModal.open({
        template: _dealNotesModal2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'saveNotes',
    value: function saveNotes() {
      this.finance.dealNotes = this.modelProp;

      this.$scope.$emit('saveFinance');

      this.closeModal();
    }
  }]);
  return FinanceQuotesController;
}();

exports.default = FinanceQuotesController;


// WEBPACK FOOTER //
// ./client/app/components/finance/financeEdit/financeQuotes/financeQuotes.controller.js